import { Instagram, Facebook, MessageCircle, ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Stagger, StaggerItem } from "@/components/motion";
import { IMAGES, CLUB } from "@/data/site";
import SectionHeading from "@/components/SectionHeading";

const CHANNELS = [
  {
    id: "instagram",
    icon: Instagram,
    name: "Instagram",
    handle: "@clubatleticobologna",
    text: "Foto e reel dagli allenamenti, dalle gare e dalla vita di tutti i giorni al club.",
    href: CLUB.instagram,
    color: "from-[#833AB4] via-[#E1306C] to-[#F77737]",
  },
  {
    id: "facebook",
    icon: Facebook,
    name: "Facebook",
    handle: "Club Atletico Bologna",
    text: "Eventi, comunicazioni ufficiali e la community dei soci e delle famiglie.",
    href: CLUB.facebook,
    color: "from-[#1877F2] to-[#0a4bad]",
  },
  {
    id: "whatsapp",
    icon: MessageCircle,
    name: "WhatsApp",
    handle: "+39 335 848 3777",
    text: "Scrivici direttamente: informazioni sui corsi e prenotazione della prova gratuita in tempo reale.",
    href: CLUB.whatsappHref,
    color: "from-[#25D366] to-[#128C7E]",
  },
];

export default function Social() {
  return (
    <div data-testid="social-page">
      <PageHero
        image={IMAGES.socialBg}
        overline="La community"
        titleLines={["Vivi il", "club online"]}
        subtitle="Seguici sui nostri canali e resta sempre aggiornato su gare, eventi e sulla vita quotidiana del Club Atletico Bologna."
      />

      {/* Channels */}
      <section className="bg-cream py-20 md:py-28" data-testid="social-channels">
        <div className="mx-auto max-w-[1400px] px-5 md:px-8">
          <SectionHeading overline="Seguici" title="I nostri canali" />
          <Stagger className="mt-14 grid gap-6 md:grid-cols-3">
            {CHANNELS.map(({ id, icon: Icon, name, handle, text, href, color }) => (
              <StaggerItem key={id}>
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`social-channel-${id}`}
                  className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-ink/10 bg-white p-8 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_60px_rgba(62,106,158,0.15)]"
                >
                  <span
                    className={`inline-flex h-14 w-14 items-center justify-center rounded-xl bg-gradient-to-br ${color} text-white shadow-lg`}
                  >
                    <Icon className="h-7 w-7" />
                  </span>
                  <h3 className="mt-6 font-display text-2xl font-extrabold uppercase tracking-tight text-ink">
                    {name}
                  </h3>
                  <p className="mt-1 font-medium text-cab">{handle}</p>
                  <p className="mt-3 flex-1 text-[15px] leading-relaxed text-muted-foreground">{text}</p>
                  <span className="mt-6 inline-flex items-center gap-2 font-bold text-ink transition-colors group-hover:text-cab">
                    Seguici ora
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </a>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      {/* Feed removed by user request */}
    </div>
  );
}
